<template>
    <div
        class="card"
        :class="widgetMode === 0 ? 'profile-header' : 'dashboard-profile-widget-card'">
        <div
            class="banner-wrapper"
            v-if="widgetMode === 0">
            <img
                class="header-image"
                id="pick-banner"
                :src="userBanner" />
            <avatar-cropper
                v-if="!teacherAccess"
                @uploaded="handleUploadedBanner"
                @error="handleError"
                @uploading="handleUploading"
                trigger="#pick-banner"
                upload-url="/profile/uploadbanner"
                :labels="labels"
                :cropperOptions="cropperOptions" />
        </div>
        <div class="avatar-wrapper">
            <img
                class="avatar-icon"
                id="pick-avatar"
                :src="userAvatar"
                @mouseover="userAvatar = avatarHoverImage"
                @mouseleave="userAvatar = avatar" />
            <avatar-cropper
                v-if="!teacherAccess"
                @uploaded="handleUploaded"
                @error="handleError"
                @uploading="handleUploading"
                trigger="#pick-avatar"
                upload-url="/profile/uploadavatar"
                :labels="labels" />
        </div>

        <div
            class="credentials"
            v-if="widgetMode === 1">
            <h4 class="name">{{ userCredentials.full_name ? userCredentials.full_name : userCredentials.name }}</h4>
            <div class="info-text">{{ userCredentials.email }}</div>
        </div>
    </div>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper';

export default {
    components: { AvatarCropper },
    name: 'design-2021-profile-widget-component',
    props: {
        image: {
            type: Object,
            default: () => {
                return undefined;
            },
        },
        banner: {
            type: Object,
            default: () => {
                return undefined;
            },
        },
        teacherAccess: {
            type: Number,
            default: () => {
                return 0;
            },
        },
        widgetMode: {
            type: Number,
            default: () => {
                return 0;
            },
        },
        userCredentials: Object,
    },
    data() {
        return {
            // avatar: this.image != undefined ? this.image.file.path : this.routes.baseUrl() + '/images/default_avatar_profile.jpg',
            avatar: null,
            avatarHoverImage: '/images/edit_avatar.jpg',
            userAvatar:
                this.image != undefined && this.image.file
                    ? this.image.file.path
                    : this.routes.baseUrl() + '/images/default_avatar_profile.jpg',
            userBanner:
                this.banner != undefined && this.image.file
                    ? this.banner.file.path
                    : this.routes.baseUrl() + '/images/profile-banner.jpg',
            labels: { submit: 'Opslaan', cancel: 'Annuleren' },
            cropperOptions: { aspectRatio: NaN },
        };
    },
    methods: {
        handleUploaded(resp) {
            this.userAvatar = resp.image.file.path;
            this.alert.success(this.$t('profile.photo_saved'), this.$t('profile.the_new_photo_is_saved'));
        },
        handleUploadedBanner(resp) {
            this.userBanner = resp.image.file.path;
            this.alert.success(this.$t('profile.photo_saved'), this.$t('profile.the_new_photo_is_saved'));
        },
        handleError(resp) {
            this.alert.ajaxError(error);
        },
        handleUploading() {
            this.alert.saving(
                this.$t('profile.save_photo'),
                this.$t('profile.the_photo_will_be_saved_please_wait_a_moment'),
            );
        },
    },
    mounted() {
        if (this.image && this.image.file) {
            if (this.image.file.image) {
                this.avatar = this.image.file.image.lowres_path;
            } else {
                this.avatar = this.image.file.path;
            }
        } else {
            this.avatar = this.routes.baseUrl() + '/images/default_avatar_profile.jpg';
        }
    },
};
</script>

<style scoped lang="scss">
.dashboard-profile-widget-card {
    background-color: transparent;
    align-items: center;
    border: none;

    .avatar-wrapper {
        img {
            width: 100px;
            height: 100px;
            border-radius: $border-radius-content;
            object-fit: cover;
            object-position: center;
        }

        img:hover {
            cursor: pointer;
        }
    }

    .credentials {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: map-get($grid-gutter-spacing, 'fifteen');

        .name {
            font-size: $base-font-size;
            font-family: $headings-font-family;
            margin-bottom: 3px;
        }

        .info-text {
            color: $text-muted-color;
            font-size: $default-font-size;
        }
    }
}

//Legacy
//.profile-header {
//    margin-top: -32px;
//    margin-bottom: 10px;
//    background: none;
//    box-shadow: none;
//}
//
//.card-body {
//    padding: 0;
//}
//
//.header-image {
//    width: 100%;
//    height: 175px;
//    box-shadow: 4px 8px 9px -2px #cdccd1;
//    -webkit-box-shadow: 4px 8px 9px -2px #cdccd1;
//    -moz-box-shadow: 4px 8px 9px -2px #cdccd1;
//    -ms-box-shadow: 4px 8px 9px -2px #cdccd1;
//    border-bottom-left-radius: 5px;
//    border-bottom-right-radius: 5px;
//    cursor: pointer;
//    object-fit: cover;
//    object-position: center;
//}
//
//.card div.avatar-wrapper {
//    padding-top: 3rem;
//    padding-bottom: 22px;
//}
//
//.avatar-icon {
//    height: 125px;
//    width: 125px;
//    position: absolute;
//    top: 110px;
//    border-radius: 100%;
//    border: 10px solid #fff;
//    background-clip: padding-box;
//    left: calc(50% - 62px);
//    background: #fff;
//    box-shadow: 4px 8px 9px -2px #cdccd1;
//    -webkit-box-shadow: 4px 8px 9px -2px #cdccd1;
//    -moz-box-shadow: 4px 8px 9px -2px #cdccd1;
//    -ms-box-shadow: 4px 8px 9px -2px #cdccd1;
//    cursor: pointer;
//}
//
//.dashboard-profile-widget-card {
//    background: transparent;
//    box-shadow: none;
//}
//
//.dashboard-profile-widget-card:first-of-type {
//    margin-top: 16px;
//}
//
//.dashboard-profile-widget-card .avatar-wrapper {
//    padding-top: 38px;
//    display: flex;
//    justify-content: center;
//}
//
//.dashboard-profile-widget-card .avatar-wrapper img {
//    height: 125px;
//    width: 125px;
//    top: unset;
//    left: unset;
//    border-width: 5px;
//    box-shadow: none;
//    cursor: pointer;
//    position: relative;
//    border-color: rgba(0, 0, 0, 0.3);
//}
//
//.credentials {
//    display: flex;
//    justify-content: center;
//    flex-direction: column;
//    padding-bottom: 15px;
//}
//
//.credentials .name {
//    font-size: 1.5625rem;
//    font-weight: 500;
//    margin-bottom: 2px;
//}
//
//.credentials .info-text {
//    color: #757575;
//    font-size: 0.8125rem;
//}
//
//.credentials .name,
//.credentials .info-text {
//    align-self: center;
//}
//
//.credentials:after {
//    content: '';
//    height: 5px;
//    width: 40px;
//    display: block;
//    position: relative;
//    background-color: rgba(33, 37, 41, 0.9);
//    left: calc(50% - 20px);
//    top: 30px;
//    margin-bottom: 30px;
//}
//
//
//@media (min-width: 992px) {
//    .header-image {
//        height: 250px;
//    }
//
//    .card div.avatar-wrapper {
//        padding-top: 10px;
//    }
//
//    .avatar-icon {
//        height: 200px;
//        width: 200px;
//        top: 80px;
//        left: calc(50% - 100px);
//    }
//}
//
//@media (min-width: 1200px) {
//    .dashboard-profile-widget-card {
//        max-width: 300px;
//        margin-left: auto;
//    }
//}
</style>
